// extracted by mini-css-extract-plugin
export var wordContainer = "_pz-0";